import React, { useEffect, useRef, useState } from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      title: 'AI & Machine Learning',
      description:
        'From predictive analytics to AI powered automation, we craft smart solutions that learn, adapt, and deliver faster business results.',
      icon: '/images/menu_icons/ai.jpg',
      accent: '#16a34a'
    },
    {
      id: 2,
      title: 'Mobile App Development',
      description:
        'We design and develop high performance mobile apps for iOS and Android, ensuring seamless user experiences and robust functionality.',
      icon: '/images/menu_icons/mobile.jpg',
      accent: '#2563eb'
    },
    {
      id: 3,
      title: 'Web Development',
      description:
        'Our web solutions combine cutting edge technologies with stunning designs, creating secure, scalable, and user friendly platforms.',
      icon: '/images/menu_icons/web.jpg',
      accent: '#7c3aed'
    },
    {
      id: 4,
      title: 'Blockchain Development',
      description:
        'We build secure, decentralized applications and smart contracts on leading blockchain platforms, enabling transparent and trustless business solutions.',
      icon: '/images/menu_icons/blockchain.jpg',
      accent: '#ea580c'
    },
    {
      id: 5,
      title: 'Game Development',
      description:
        'We create immersive gaming experiences across platforms from casual mobile games to complex multiplayer environments using Unity, Unreal, and custom engines.',
      icon: '/images/menu_icons/game.jpg',
      accent: '#16a34a'
    },
    {
      id: 6,
      title: 'IoT Development',
      description:
        'We design and develop connected device solutions - from sensor integration and embedded systems to cloud platforms that turn data into actionable insights.',
      icon: '/images/menu_icons/iot.jpg',
      accent: '#2563eb'
    },
    {
      id: 7,
      title: 'CRM & ERP Solutions',
      description:
        'We build custom CRM and ERP systems that streamline operations, automate workflows, and provide real-time insights to drive business growth.',
      icon: '/images/menu_icons/crm.jpg',
      accent: '#2563eb'
    },
    {
      id: 8,
      title: 'Cloud & DevOps',
      description:
        'We architect, deploy, and manage scalable cloud infrastructure on AWS, Google Cloud, and Azure with CI/CD pipelines, containerization, and 24/7 monitoring.',
      icon: '/images/menu_icons/cloud.jpg',
      accent: '#16a34a'
    }
  ];

  const [visibleCards, setVisibleCards] = useState([]);
  const cardRefs = useRef([]);

  useEffect(() => {
    const observers = cardRefs.current.map((ref, index) => {
      if (!ref) return null;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setVisibleCards((prev) => [...new Set([...prev, index])]);
            }
          });
        },
        { threshold: 0.15 }
      );

      observer.observe(ref);
      return observer;
    });

    return () => {
      observers.forEach((observer) => observer?.disconnect());
    };
  }, []);

  return (
    <section className="services expertise-section" id="services">
      <div className="services-container">
        <div className="services-heading expertise-heading">
          <h2>
            Our <span className="expertise-heading__highlight">Expertise</span>
          </h2>
          <p>
            We deliver end-to-end digital solutions using the latest technologies to help businesses innovate, grow, and succeed.
          </p>
        </div>

        <div className="services-grid expertise-grid">
          {services.map((service, index) => (
            <div
              key={service.id}
              ref={(el) => (cardRefs.current[index] = el)}
              className={`service-card expertise-card ${visibleCards.includes(index) ? 'visible' : ''}`}
              style={{ '--delay': `${index * 0.08}s`, '--accent': service.accent }}
            >
              <div className="expertise-card__wave" aria-hidden="true" />
              <div className="expertise-card__inner">
                <div className="expertise-card__icon-wrap">
                  <img src={service.icon} alt="" className="expertise-card__icon" />
                </div>
                <h3>{service.title}</h3>
                <span className="expertise-card__accent-line" aria-hidden="true" />
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
